(function () {
  'use strict';

  if (!document.body.classList.contains('luxury-faq')) return;

  /* Scroll reveal */
  var reveals = document.querySelectorAll('[data-reveal]');
  if (reveals.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -30px 0px' }
    );
    reveals.forEach(function (el) {
      observer.observe(el);
    });
  } else {
    reveals.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  /* Accordion */
  document.querySelectorAll('.luxury-faq-item__trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = trigger.closest('.luxury-faq-item');
      if (!item) return;

      var isOpen = item.classList.contains('is-open');
      var group = item.closest('.luxury-faq-list');

      if (group) {
        group.querySelectorAll('.luxury-faq-item.is-open').forEach(function (openItem) {
          if (openItem !== item) {
            openItem.classList.remove('is-open');
            openItem.querySelector('.luxury-faq-item__trigger').setAttribute('aria-expanded', 'false');
          }
        });
      }

      item.classList.toggle('is-open', !isOpen);
      trigger.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
    });
  });

  /* Category nav scroll spy */
  var navLinks = document.querySelectorAll('.luxury-faq-nav__link');
  var categories = document.querySelectorAll('.luxury-faq-category');

  if (navLinks.length && categories.length) {
    navLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.querySelector(link.getAttribute('href'));
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var spyObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var id = entry.target.id;
              navLinks.forEach(function (link) {
                link.classList.toggle('is-active', link.getAttribute('href') === '#' + id);
              });
            }
          });
        },
        { rootMargin: '-30% 0px -60% 0px' }
      );
      categories.forEach(function (cat) {
        spyObserver.observe(cat);
      });
    }
  }
})();
